/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
  RESET_TRAVEL_DELAY_STATE,
  RESET_AIRLINE_FOR_DAMAGED_STATE,
  RESET_AIRLINE_BAGGAGE_DELAY_STATE,
  GET_FLIGHT_STATUS_REQUEST,
  GET_FLIGHT_STATUS_SUCCESS,
  GET_FLIGHT_STATUS_ERROR,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormTravelInterruption() {
  return {
    type: RESET_TRAVEL_INTERRUPTION_STATE,
  };
}
export function resetFormTravelDelay() {
  return {
    type: RESET_TRAVEL_DELAY_STATE,
  };
}

export function resetFormAirlineForDamaged() {
  return {
    type: RESET_AIRLINE_FOR_DAMAGED_STATE,
  };
}
export function resetFormAirlineBaggageDelay() {
  return {
    type: RESET_AIRLINE_BAGGAGE_DELAY_STATE,
  };
}

export function getFlightStatusRequest(flightNumber, flightDate, flightObjectName, currentStepName) {
  return {
    type: GET_FLIGHT_STATUS_REQUEST,
    flightNumber,
    flightDate,
    flightObjectName,
    currentStepName,
  };
}

export function getFlightStatusSuccess(flightData, flightObjectName) {
  return {
    type: GET_FLIGHT_STATUS_SUCCESS,
    payload: flightData,
    flightObjectName,
  };
}

export function getFlightStatusError(error, flightObjectName) {
  return {
    type: GET_FLIGHT_STATUS_ERROR,
    error,
    flightObjectName,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/actions.js